import isClientPending from './is_client_pending';

/* eslint-disable import/prefer-default-export */
export {
  isClientPending,
};
